<template>
    <Avatar
        :image="avatarUrl || undefined"
        :label="avatarUrl ? undefined : initials || undefined"
        :icon="avatarUrl || initials ? undefined : 'far fa-user'"
        :size="size"
        shape="circle"
        class="user-avatar" />
</template>

<script setup lang="ts">
import { computed } from "vue";
import Avatar from "primevue/avatar";
import { getUserInitials } from "@/utils/userNames";
import type { CurrentUserResponse } from "@/types/api";

const props = defineProps<{
    user?: CurrentUserResponse | null;
    size?: "normal" | "large" | "xlarge";
}>();

const avatarUrl = computed(() => props.user?.profile?.avatar);
const initials = computed(() =>
    getUserInitials({
        ...props.user?.profile,
        displayName: props.user?.displayName,
    }),
);
</script>

<style scoped>
.user-avatar {
    background-color: var(--primary-color);
    color: var(--primary-color-text);
    /* Matches the secondary outlined button border; the theme has no variable for it. */
    border: 1px solid #94a3b8;
}
</style>
